module.exports = __webpack_public_path__ + "static/img/login-image.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login-image.jpg
// module id = HgM1
// module chunks = 1